import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import { Tn, kn, yn, En, Rn, _n, f, E } from '../helper/utils/getHash';
import { checkType } from '../helper/utils/common';
/**
 * 获取webgl信息
 * @returns
 */

var _t = function t() {
  return (_t = _Object$assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      for (var i in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      }
    }

    return e;
  }).apply(this, arguments);
};

var getWebgl = function getWebgl() {
  var emptyStr = {
    contextAttributes: '',
    parameters: '',
    shaderPrecisions: '',
    extensions: '',
    extensionParameters: '',
    fingerprint: ''
  };

  try {
    for (var e = document.createElement('canvas'), n = ['webgl', 'experimental-webgl'], r = void 0, i = 0; i < n.length && !r; i++) {
      try {
        r = e.getContext(n[i]);
      } catch (a) {
        console.error(a);
      }

      if (r) {
        var o = _t(_t({}, function (e) {
          var t,
              n,
              r,
              i,
              o,
              a,
              u = e.getSupportedExtensions(),
              s = e.getExtension('WEBGL_debug_renderer_info'),
              c = e.getContextAttributes(),
              l = [],
              d = [],
              f = [],
              v = [];

          for (var h in c) {
            Object.prototype.hasOwnProperty.call(c, h) && l.push(h + '=' + c[h]);
          }

          for (var p = 0, m = Tn(e); p < m.length; p++) {
            var g = e[_ = m[p]];
            kn.indexOf(g) > -1 ? d.push(_ + '(' + g + ')=' + e.getParameter(g)) : d.push(_ + '=' + g);
          }

          if (u) for (var b = 0, w = u; b < w.length; b++) {
            var y = w[b],
                k = e.getExtension(y);
            if (k) for (var E = 0, R = Tn(k); E < R.length; E++) {
              var _;

              g = k[_ = R[E]], yn.indexOf(_) > 0 ? f.push(_ + '(' + g + ')=' + e.getParameter(g)) : f.push(_ + '=' + g);
            }
          }

          for (var S = 0, T = En; S < T.length; S++) {
            for (var C = T[S], A = 0, I = Rn; A < I.length; A++) {
              var x = I[A],
                  O = _n(e, C, x);

              v.push(C + '.' + x + '=' + O.join(','));
            }
          }

          return f.sort(), d.sort(), {
            version: (null === (t = e.getParameter(e.VERSION)) || void 0 === t ? void 0 : t.toString()) || '',
            vendor: (null === (n = e.getParameter(e.VENDOR)) || void 0 === n ? void 0 : n.toString()) || '',
            vendorUnmasked: s ? null === (r = e.getParameter(s.UNMASKED_VENDOR_WEBGL)) || void 0 === r ? void 0 : r.toString() : '',
            renderer: (null === (i = e.getParameter(e.RENDERER)) || void 0 === i ? void 0 : i.toString()) || '',
            rendererUnmasked: s ? null === (o = e.getParameter(s.UNMASKED_RENDERER_WEBGL)) || void 0 === o ? void 0 : o.toString() : '',
            shadingLanguageVersion: (null === (a = e.getParameter(e.SHADING_LANGUAGE_VERSION)) || void 0 === a ? void 0 : a.toString()) || '',
            contextAttributes: l.join('&'),
            parameters: d.join('&'),
            shaderPrecisions: v.join('&'),
            extensions: u ? u.join(',') : '',
            extensionParameters: f.join(',')
          };
        }(r)), {
          fingerprint: ''
        });

        return function (e) {
          e.clearColor(0, 0, 1, 1);
          var t = e.createProgram();

          if (t) {
            i(0, 'attribute vec2 p;uniform float t;void main(){float s=sin(t);float c=cos(t);gl_Position=vec4(p*mat2(c,s,-s,c),1,1);}'), i(1, 'void main(){gl_FragColor=vec4(1,0,0,1);}'), e.linkProgram(t), e.useProgram(t), e.enableVertexAttribArray(0);
            var n = e.getUniformLocation(t, 't'),
                r = e.createBuffer();
            e.bindBuffer(34962, r), e.bufferData(34962, new Float32Array([0, 1, -1, -1, 1, -1]), 35044), e.vertexAttribPointer(0, 2, 5126, !1, 0, 0), e.clear(16384), e.uniform1f(n, 3.65), e.drawArrays(4, 0, 3);
          }

          function i(n, r) {
            var i = e.createShader(35633 - n);
            t && i && (e.shaderSource(i, r), e.compileShader(i), e.attachShader(t, i));
          }
        }(r), o.fingerprint = e.toDataURL() || '', o;
      } else {
        return emptyStr;
      }
    }
  } catch (e) {
    return emptyStr;
  }
};

export var getWebglAttribute = function getWebglAttribute() {
  var o = getWebgl();
  var xe = f;
  return {
    hash: {
      contextAttributes: checkType(xe(o.contextAttributes), 'string'),
      parameters: checkType(xe(o.parameters), 'string'),
      shaderPrecisions: checkType(xe(o.shaderPrecisions), 'string'),
      extensions: checkType(xe(o.extensions), 'string'),
      extensionParameters: checkType(xe(o.extensionParameters), 'string'),
      fingerprint: checkType(xe(o.fingerprint), 'string')
    },
    attribute: o || {}
  };
};